import { render, staticRenderFns } from "./ProfilViewer.vue?vue&type=template&id=68d53573&scoped=true"
import script from "./ProfilViewer.vue?vue&type=script&lang=js"
export * from "./ProfilViewer.vue?vue&type=script&lang=js"
import style0 from "./ProfilViewer.vue?vue&type=style&index=0&id=68d53573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d53573",
  null
  
)

export default component.exports